import { config } from '@abyss/ui/tools/config';
import { useQuery } from '../../tools/useQuery';

const parseResult = result => {
  const initialState = [];

  if (result) {
    const res = {
      optum_uuid: result.uuid,
      optum_id: result.oneHealthId,
      user_type: result.userType,
    };
    return [res];
  }

  return initialState;
};

export const usePasswordOwner = options => {
  const url = `${config('DS_STARGATE_API_URL')}/paa/v1.0`;

  const [queryResult, queryAction] = useQuery(url, {
    ...options,
    onCompleted: result => {
      options.onCompleted(parseResult(result.body));
    },
    onError: error => {
      const id = 'technical-user-get-password-owner';
      let code = error.statusCode;
      let type;
      if (error.status === 404) {
        code = 'PO_NOT_FOUND';
        type = 'warning';
      }
      options.onError({ ...error, id, code, type });
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
